(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.score = 0;
        this.gameStatus = "idle";
        this.board = initialState || this.createEmptyBoard();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var changed = this.handleMove(this.board, false);
                if (changed) {
                    this.addRandomTile();
                    this.checkGameOver();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var changed = this.handleMove(this.board, true);
                if (changed) {
                    this.addRandomTile();
                    this.checkGameOver();
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var transposed = this.transpose(this.board);
                var changed = this.handleMove(transposed, false);
                if (changed) {
                    this.board = this.transpose(transposed);
                    this.addRandomTile();
                    this.checkGameOver();
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var transposed = this.transpose(this.board);
                var changed = this.handleMove(transposed, true);
                if (changed) {
                    this.board = this.transpose(transposed);
                    this.addRandomTile();
                    this.checkGameOver();
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.gameStatus;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.gameStatus === "idle") {
                    this.gameStatus = "playing";
                    this.board = this.createEmptyBoard();
                    this.addRandomTile();
                    this.addRandomTile();
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.score = 0;
                this.gameStatus = "idle";
                this.start();
            }
        },
        {
            key: "handleMove",
            value: function handleMove(grid, reverse) {
                var _this = this, _loop = function(i) {
                    var row = (0, $227c6742e0ff6f82$export$71511d61b312f219)(grid[i]);
                    if (reverse) row.reverse();
                    var filtered = row.filter(function(v) {
                        return v !== 0;
                    });
                    for(var j = 0; j < filtered.length - 1; j++)if (filtered[j] === filtered[j + 1]) {
                        filtered[j] *= 2;
                        _this.score += filtered[j];
                        filtered[j + 1] = 0;
                        if (filtered[j] === 2048) _this.gameStatus = "win";
                    }
                    var merged = filtered.filter(function(v) {
                        return v !== 0;
                    });
                    var newRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(merged).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(Array(_this.size - merged.length).fill(0)));
                    if (reverse) newRow.reverse();
                    if (!_this.arraysEqual(newRow, grid[i])) {
                        grid[i] = newRow;
                        changed = true;
                    }
                };
                var changed = false;
                for(var i = 0; i < this.size; i++)_loop(i);
                return changed;
            }
        },
        {
            key: "transpose",
            value: function transpose(matrix) {
                return matrix[0].map(function(_, i) {
                    return matrix.map(function(row) {
                        return row[i];
                    });
                });
            }
        },
        {
            key: "arraysEqual",
            value: function arraysEqual(a, b) {
                return a.every(function(val, i) {
                    return val === b[i];
                });
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var empty = [];
                for(var a = 0; a < this.size; a++){
                    for(var b = 0; b < this.size; b++)if (this.board[a][b] === 0) empty.push([
                        a,
                        b
                    ]);
                }
                if (!empty.length) return;
                var _empty_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(empty[Math.floor(Math.random() * empty.length)], 2), i = _empty_Math_floor[0], j = _empty_Math_floor[1];
                this.board[i][j] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "checkGameOver",
            value: function checkGameOver() {
                var _this = this;
                if (this.board.some(function(row) {
                    return row.includes(2048);
                })) return;
                if (this.board.some(function(row) {
                    return row.includes(0);
                })) return;
                var directions = [
                    this.moveLeftPreview,
                    this.moveRightPreview,
                    this.moveUpPreview,
                    this.moveDownPreview
                ];
                if (directions.some(function(fn) {
                    return fn.call(_this);
                })) return;
                this.gameStatus = "lose";
            }
        },
        {
            key: "moveLeftPreview",
            value: function moveLeftPreview() {
                return this.board.some(function(row) {
                    for(var i = 0; i < row.length - 1; i++){
                        if (row[i] === row[i + 1]) return true;
                    }
                    return false;
                });
            }
        },
        {
            key: "moveRightPreview",
            value: function moveRightPreview() {
                return this.moveLeftPreview();
            }
        },
        {
            key: "moveUpPreview",
            value: function moveUpPreview() {
                var transposed = this.transpose(this.board);
                return transposed.some(function(row) {
                    for(var i = 0; i < row.length - 1; i++){
                        if (row[i] === row[i + 1]) return true;
                    }
                    return false;
                });
            }
        },
        {
            key: "moveDownPreview",
            value: function moveDownPreview() {
                return this.moveUpPreview();
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$scoreElem = document.querySelector(".game-score");
var $197cd56b15c33885$var$startBtn = document.querySelector(".button");
var $197cd56b15c33885$var$msgStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$msgWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$msgLose = document.querySelector(".message-lose");
function $197cd56b15c33885$var$renderBoard() {
    var state = $197cd56b15c33885$var$game.getState().flat();
    $197cd56b15c33885$var$cells.forEach(function(cell, idx) {
        var val = state[idx];
        cell.textContent = val === 0 ? "" : val;
        cell.className = "field-cell";
        if (val) cell.classList.add("field-cell--".concat(val));
    });
    $197cd56b15c33885$var$scoreElem.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$updateMessages();
}
function $197cd56b15c33885$var$updateMessages() {
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$msgStart.classList.toggle("hidden", gameStatus !== "idle");
    $197cd56b15c33885$var$msgWin.classList.toggle("hidden", gameStatus !== "win");
    $197cd56b15c33885$var$msgLose.classList.toggle("hidden", gameStatus !== "lose");
    if (gameStatus === "playing") {
        $197cd56b15c33885$var$startBtn.classList.replace("start", "restart");
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
    } else {
        $197cd56b15c33885$var$startBtn.classList.replace("restart", "start");
        $197cd56b15c33885$var$startBtn.textContent = "Start";
    }
}
$197cd56b15c33885$var$startBtn.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$renderBoard();
});
document.addEventListener("keydown", function(e) {
    var key = e.key;
    switch(key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderBoard();
});
$197cd56b15c33885$var$renderBoard();

})();
//# sourceMappingURL=index.1e327d7e.js.map
